module.exports = __webpack_public_path__ + "img/03-revisit-our-regional-conference.2e7a7771.jpg";